/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'

const GtagWrapper = ({ onLoad }: any) => {
  useEffect(() => {
    const scriptElement = document.createElement('script')
    scriptElement.src = `https://www.googletagmanager.com/gtag/js?id=${GTM_ID}`
    scriptElement.async = true
    scriptElement.onload = onLoad
    scriptElement.onerror = () => {
      window.gtag = (...args: any) => {
        console.log(...args)
      }
      onLoad()
    }

    document.head.appendChild(scriptElement)
  }, [])

  return (
    <Helmet>
      <script>
        {`
        window.dataLayer = window.dataLayer || [];
        function gtag() {dataLayer.push(arguments); }
        gtag('js', new Date());
  
        gtag('config', '${GTM_ID}');
      `}
      </script>
    </Helmet>
  )
}

export default GtagWrapper
